import { axios } from "../util/axios";

const form_header = {
    "Content-Type": "multipart/form-data; charset=UTF-8",
};

const auth = {
    login: ({ email, password }) =>
        axios.post("/managers/auth", { email, password }),
    loginCheck: () => axios.post("/managers/check/auth"),
};

const product = {
    getServiceList: () => axios.get("/products/service"),
    getServiceData: ({ service_id }) =>
        axios.get(`/products/all/${service_id}`),
};

const priceTagSystem = {
    getServiceList: () => axios.post("/service/list"),
    getService: (service_id) => axios.post(`/service/${service_id}`),
    addProject: (data) => axios.post("/estimateProject/add", data),
    editProject: (data) => axios.post("/estimateProject/update", data),
    delProject: (data) => axios.delete(`/estimateProject/delete/${data}`),
    getProjectList: (data) => {
        return axios.post("/estimateProject/list", data);
    },
    searchProject: (page = 1, size = 20, keyword = "") =>
        axios.post(`/vestimate/list`, {
            page: page,
            pageSize: size,
            searchtxt: keyword,
        }),
    getProject: (service_id) => {
        return axios.post(`/estimateProject/${service_id}`);
    },
};

const board = {
    getBoard: () => axios.get(`board/list`),
    getBoardDetail: ({ id }) => axios.get(`board/detail`, { params: { id } }),
    addBoardFiles: ({ files, category = "" }) =>
        axios.post(`/board/upload`, files, {
            headers: form_header,
            params: { category },
        }),
    saveBoard: ({
        manager_id,
        id,
        category,
        progress,
        title,
        content,
        is_main,
        file = [],
    }) =>
        axios.post(`board/savepost`, {
            manager_id,
            id,
            category,
            progress,
            title,
            content,
            is_main,
            file,
        }),
    setIsMain: ({ id, is_main }) =>
        axios.get(`board/setmain`, { params: { id, is_main } }),
    deleteBoard: ({ id }) => axios.get(`board/delete`, { params: { id } }),
};

const file = {
    getFiles: () => axios.get(`file/listfiles`),
    addFiles: ({ files, category = "" }) =>
        axios.post(`/file/upload`, files, {
            headers: form_header,
            params: { category },
        }),
    deleteFile: ({ id }) => axios.get(`file/deletefile`, { params: { id } }),
};

const admin = {
    getProductItems: () => axios.get(`/productItem/list`),
    getMangerList: () => axios.get(`managers/list`),
    addManager: ({
        email = "",
        name = "",
        password = "",
        permit_pts = 0,
        permit_dta = 0,
        permit_notice = 0,
        team = "",
    }) =>
        axios.post(`managers/register`, {
            email,
            name,
            password,
            permit_pts,
            permit_dta,
            permit_notice,
            team,
        }),
    modManager: (data, id) => axios.post(`/managers/mod/${id}`, data),
    delManager: (id) => axios.post(`managers/auth/del/${id}`),
};

const dataTagAdmin = {
    //images : 이미지 파일 배열, inbound_num: 인바운드 넘버 없을 경우 0, room_type: 룸 타입(거실 등) 없을 경우 "common"
    saveImages: (data) =>
        axios.post(`/tag/saveimage`, data, { headers: form_header }),
    getProject: (project_id) =>
        axios.get(`/tag/details?project_id=${project_id}`),
    addProject: (project_data = {}) =>
        axios.post(`/tag/savetag`, { ...project_data }),
    getImages: (current_page = 1, size = 20, keyword = "") =>
        axios.get(`/tag/listimages`, {
            params: { current_page, size, keyword },
        }),
    modProject: (project_data = {}) =>
        axios.post(`/tag/modifytag`, { ...project_data }),
    searchProjects: (page = 1, size = 20, search_data = {}) =>
        axios.post(`/tag/searchprojects?current_page=${page}&size=${20}`, {
            ...search_data,
        }),
    searchTags: (page = 1, size = 20, search_data = {}) =>
        axios.post(`/tag/search?current_page=${page}&size=${20}`, {
            ...search_data,
        }),
    deleteProject: (project_id) =>
        axios.get(`/tag/delete?project_id=${project_id}`),
};

const portfolioFinder = {
    searchTags: ({
        size = 20,
        current_page = 1,
        search_criteria = [],
        room_criteria = "",
        square_criteria = "",
        region_criteria = "",
        apt_criteria = "",
        manager_criteria = "",
        family_number,
        budget = "",
    }) =>
        axios.post(
            `/pff/search`,
            {
                search_criteria,
                room_criteria,
                square_criteria,
                region_criteria,
                apt_criteria,
                manager_criteria,
                family_number,
                budget,
            },
            {
                params: { size, current_page },
            }
        ),
    getList: ({ size = 20, current_page = 1 }) =>
        axios.get(`/pff/list`, {
            params: {
                size,
                current_page,
            },
        }),
    getPortfolio: ({ project_id }) =>
        axios.get(`/pff/detail`, { params: { project_id } }),
    searchPortfolio: ({ criteria = "" }) =>
        axios.get(`/pff/listsearch`, { params: { criteria } }),
    savePortfolio: ({ user_info = {}, project_info = {}, image_ids = [] }) =>
        axios.post(`/pff/save`, {
            user_info,
            project_info,
            image_ids,
        }),
    editPortfolio: ({ user_info = {}, project_info = {}, image_ids = [] }) =>
        axios.post(`/pff/modify`, {
            user_info,
            project_info,
            image_ids,
        }),
    deletePortfolio: ({ project_id }) =>
        axios.get(`/pff/delete`, { params: { project_id } }),
    getStats: ({ filter }) =>
        axios.post(`/pff/statistic`, {
            filter: {
                start_date: filter.start_date || "0000-00-00 00:00:00",
                end_date: filter.end_date || "9999-12-31 23:59:59",
            },
        }),
};

export default {
    auth,
    product,
    admin,
    board,
    file,
    priceTagSystem,
    dataTagAdmin,
    portfolioFinder,
};
